const rydw = [
    {
        path: 'degionDrawing',
        name: 'degionDrawing',
        component: () => import('@/components/personnelPosition/degionDrawing'),
        meta: { title: '区域绘制', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'regionalAlarm',
        name: 'regionalAlarm',
        component: () => import('@/components/personnelPosition/regionalAlarm'),
        meta: { title: '区域报警', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'cameraManage',
        name: 'cameraManage',
        component: () => import('@/components/personnelPosition/cameraManage'),
        meta: { title: '摄像头管理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'integraSystem',
        name: 'integraSystem',
        component: () => import('@/components/personnelPosition/integraSystem'),
        meta: { title: '子系统融合', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'peopleManager',
        name: 'peopleManager',
        component: () => import('@/components/personnelPosition/peopleManager'),
        meta: { title: '人员管理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'alarmProcessing',
        name: 'alarmProcessing',
        component: () => import('@/components/personnelPosition/alarmProcessing'),
        meta: { title: '报警处理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'cardManagement',
        name: 'cardManagement',
        component: () => import('@/components/personnelPosition/cardManagement'),
        meta: { title: '定位卡管理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'beaconManagement',
        name: 'beaconManagement',
        component: () => import('@/components/personnelPosition/beaconManagement'),
        meta: { title: '信标管理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'baseManagement',
        name: 'baseManagement',
        component: () => import('@/components/personnelPosition/baseManagement'),
        meta: { title: '基站管理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'floorManagement',
        name: 'floorManagement',
        component: () => import('@/components/personnelPosition/floorManagement'),
        meta: { title: '楼层管理', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'alarmConfig',
        name: 'alarmConfig',
        component: () => import('@/components/personnelPosition/alarmConfig'),
        meta: { title: '报警配置', requireAuth: true, keepAlive: true, permission: true }
    },
    {
        path: 'lowBatteryAlarmRegister',
        name: 'lowBatteryAlarmRegister',
        component: () => import('@/components/personnelPosition/lowBatteryAlarmRegister'),
        meta: { title: '低电报警台账', requireAuth: true, keepAlive: true, permission: true }
    },
    
  ]
  export default rydw


// WEBPACK FOOTER //
// ./src/router/rydw.js